import { Model, Prop, Vue } from "vue-property-decorator";
import { Options, setup } from "vue-class-component";
import AppRangeSliderComponent from "@/shared/vehicles/left-filter/range-slider/range-slider.vue";
import {
    RangeFilterItemDto,
    VehicleFilterType,
} from "@/shared/api-contract/api-contract";
import "./range-slider.scss";
import { useI18n } from "@/shared/composables/use-i18n";
import { AppRangeSliderModel } from "@/shared/components/app-range-slider/app-range-slider-model";

@Options({
    components: {
        "app-range-slider": AppRangeSliderComponent,
    },
})
export class RangeSlider extends Vue {
    @Prop({ required: true })
    type!: VehicleFilterType;
    @Model("modelValue", { required: true })
    model!: AppRangeSliderModel;
    @Prop({ type: Array, required: true })
    options!: RangeFilterItemDto[];
    i18n = setup(useI18n);
    isOpen = false;

    @Prop({ type: Boolean, default: false })
    selectMode!: boolean;

    @Prop({ type: Number })
    selectModeForMainFilter?: 1 | 2 | 3 | 4;

    @Model("selected")
    selectedModel!: boolean;

    get iconName() {
        switch (this.type) {
            case VehicleFilterType.emissionWltp:
            case VehicleFilterType.emissionNedc:
                return "emission";
            case VehicleFilterType.damage:
                return "schadebedrag";
            case VehicleFilterType.mileage:
                return "kilometers";
            default:
                return this.type;
        }
    }

    get filterClasses() {
        return {
            selected: this.selectMode && this.selectedModel,
            fill: (() => {
                switch (this.type) {
                    case VehicleFilterType.emissionNedc:
                    case VehicleFilterType.emissionWltp:
                    case VehicleFilterType.damage:
                        return true;
                    default:
                        return false;
                }
            })(),
            stroke: (() => {
                switch (this.type) {
                    case VehicleFilterType.firstregistrationYear:
                    case VehicleFilterType.mileage:
                        return true;
                    default:
                        return false;
                }
            })(),
        };
    }

    get rangeUnit() {
        switch (this.type) {
            case VehicleFilterType.emissionWltp:
            case VehicleFilterType.emissionNedc:
                return this.i18n.t("dashboard.settings.filtersUnits.emission");
            case VehicleFilterType.mileage:
                return this.i18n.t("dashboard.settings.filtersUnits.mileage");
            default:
                return "";
        }
    }

    buttonClick(event: UIEvent) {
        if (this.selectMode) {
            const target = event.target;
            const innerButtonClick =
                target instanceof Element && target.closest(".filter-btn__block");
            if (!innerButtonClick) {
                this.selectedModel = !this.selectedModel;
            }
        } else {
            this.isOpen = !this.isOpen;
        }
    }

    innerButtonClick() {
        if (this.selectMode) {
            this.isOpen = !this.isOpen;
        }
    }
}
